import { AggregationType, FieldType, fieldTypeToOutputType } from "@dto/fields";
import { CurrencyFieldFormatSection } from "./CurrencyFieldFormatSection";
import { DateFieldFormatSection } from "./DateFieldFormatSection";
import { NumberFieldFormatSection } from "./NumberFieldFormatSection";
import { PeriodFieldFormatSection } from "./PeriodFieldFormatSection";
import { TextFieldFormatSection } from "./TextFieldFormatSection";

export interface FieldFormatSectionProps {
    fieldType: FieldType;
    fieldTypeItems: Map<string, any> | undefined;
    format: Map<string, any> | undefined;
    aggregation: AggregationType | undefined;
    onFormatChange: (key: string, isCheckbox: boolean) => (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export function FieldFormatSection({ fieldType, fieldTypeItems, format, aggregation, onFormatChange }: FieldFormatSectionProps) {

    const outputType = fieldTypeToOutputType(fieldType, aggregation);
    switch (outputType) {
        case FieldType.Text:
            return <TextFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.TextArea:
            return <TextFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.Url:
            return <TextFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
            case FieldType.Number:
            return <NumberFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.Decimal:
            return <NumberFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.Percent:
            return <NumberFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.Devise:
            return <CurrencyFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.Date:
            return <DateFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        case FieldType.Period:
            return <PeriodFieldFormatSection fieldType={fieldType} fieldTypeItems={fieldTypeItems} format={format} aggregation={aggregation} onFormatChange={onFormatChange} />
        default:
            return <div></div>
    }
}
